export const TutorialType = {
  pilotUserOnboardingBanner: 1,
  b2bNewUserOnboardingBanner: 2,
  homePageTutorial: 3,
  billPaymentTutorial: 4, //Deprecated, use unpaidBillsTutorial instead
  manageAccountTutorial: 5,
  manageAccountAddAccountsTutorial: 6,
  manageAccountEditAccountTutorial: 7,
  manageAccountAccountByGroupTutorial: 8,
  manageUserTutorial: 9,
  profileTutorial: 10,
  adminBulkAccountsTutorial: 11,
  adminManageBulkAccountTutorial: 12,
  adminManageElectricityAccTutorial: 13,
  adminManageUserTutorial: 14,
  adminPaymentTutorial: 15,
  adminManageTNBUserTutorial: 16,
  adminProfileTutorial: 17,
  paymentsTutorial: 18,
  flexiblePaymentTutorial: 19,
  unpaidBillsTutorial: 20,
  downloadBillsTutorial: 21,
  billHistoryTutorial: 22,
  searchBillsTutorial: 23,
};